import { render, staticRenderFns } from "./Time.vue?vue&type=template&id=22c0ebac&scoped=true"
import script from "./Time.vue?vue&type=script&lang=js"
export * from "./Time.vue?vue&type=script&lang=js"
import style0 from "./Time.vue?vue&type=style&index=0&id=22c0ebac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c0ebac",
  null
  
)

export default component.exports